
import React, {useState, useEffect} from 'react';
import { Form, Field } from 'react-final-form';
import { TextField } from 'final-form-material-ui';
import Snackbar from '@material-ui/core/Snackbar';
import {Paper,
  Grid,
  Button 
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { green } from '@material-ui/core/colors';
import clsx from 'clsx';


import CircularProgress from '@material-ui/core/CircularProgress';
import {useDataProvider,useNotify} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import AppBar from "../../header/index"
import AppProvider from "./../../bootstrap/index"
import * as yup from "yup"
import { setIn } from "final-form";
import Parse from 'parse'
const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  
  form: {
    width: '100%', 
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  TextField:{
    marginTop:"8%",
    backgroundColor:"#ffffff"
  },
  coverBackgroundContainer: {
    backgroundColor:"#F7F8F9",
    height: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft:"4%",
    paddingRight:"4%",
    paddingTop:"40px",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
    width:'100%'
  },
  buttonSuccess: {
    backgroundColor: 'primary',
    width:'100%',
    '&:hover': {
      backgroundColor: 'primary',
    },
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));
// const onSubmit = async values => {
  

//   const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
//   await sleep(300);
//   console.log("values",values)
//   // const data=await Parse.Cloud.run("payment",{data:values})
// };


const validationSchema = yup.object({  
  accountNumber: yup
        .string().matches( /^\d{10,12}$/,"Account number must be 10 or 12 digits" ),  
 IFSC: yup
    .string()
    .matches(
      /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/,
      "Incorrect IFSC code"
    )
    .required("IFSC code is required."),
    accountName: yup
    .string()
    .matches(
      /(^[a-zA-Z ]+$)/,
      "Account Name Must be only character"
    )
    .required("Account Name is required."), 
});

export const validatePaymentForm = async values => {
  try {
    await validationSchema.validate(values, { abortEarly: false });
  } catch (err) {
    const errors = err.inner.reduce((formError, innerError) => {
      return setIn(formError, innerError.path, innerError.message);
    }, {});
    console.log(errors);
    return errors;
  }

  
};


export  const UpdatePaymentDetails=()=> {
  const classes = useStyles();
  const notify= useNotify();
  const dataProvider=useDataProvider()
  // const dataProvider= useDataProvider();
  const [dataList,setDataList]=useState([]);
  const [currentUser,setCurrentUser]= useState("");

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [open, setOpen] = useState(false);

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(()=>{
    const user = Parse.User.current();
    user.fetch().then(function(fetchedUser){
      setCurrentUser(fetchedUser.id);
    });
    const runEffect = async () => {
  const data = await dataProvider.getList("PaymentDetail", {
  filter: {},
  pagination: { page: 1, perPage: 10 },
  sort: { field: "id", order: "ASC" }
  });
  console.log("dat--->",data)
  setDataList(
  data.data.map(key => ({
    currentUserId:key.currentUserId,
  id: key.id,
  accountName: key.accountName,
  accountNumber:key.accountNumber,
  IFSC:key.IFSC,
  bankName:key.bankName
  }))
  );
  };
  runEffect();
  }, [setDataList, dataProvider]);
  
console.log("currentuser->",currentUser)

// useEffect(() => {
  console.log("======",dataList.currentUserId)
  // for(let i=0;i<dataList;i++)
  // {
  console.log("this is data from User=>",dataList[5])
  // }
  const handleButtonClick = async (values) => {

    try{
      if (!loading) {
        setSuccess(false);
        setLoading(true);
        await dataProvider.create("PaymentDetails",{data:values})
        // notify("Payment details added")
       
      }
    }catch(e){
        notify("Error while adding payment details ",e.message)
    }finally{
      setSuccess(true);
      setLoading(false);
    }
    // console.log("--------=------+_-------")
    setOpen(true)
  };

  return (
    
    <div className={classes.coverBackgroundContainer}>
        <AppProvider >   
           <AppBar/>         
         <Container component="main" maxWidth="xs" style={{background:"#ffffff",}}>    
           <Typography component="h6" variant="h6" style={{paddingTop:"7%",marginLeft:"20%"}}>
               Update Payment Details
             </Typography>  
      <Form
        onSubmit={handleButtonClick}
        validate={validatePaymentForm}
        render={({ handleSubmit, reset, submitting, pristine, values }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Paper style={{ padding: 16 ,boxShadow: "none"}}>
              <Grid container alignItems="flex-start" spacing={2}>                
                <Grid item xs={12}>
                  <Field
                    name={dataList.accountName}
                    fullWidth
                    // required
                    // source="key.accountName"
                    component={TextField}
                    type="text"
                    label="Account Name"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    // required
                    name="accountNumber"
                    component={TextField}
                    type="number"
                    label="Account Number"
                  />
                </Grid>             
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    name="IFSC"
                    component={TextField}
                    type="text"
                    label="IFSC Code"
                  />
                  </Grid>
                  <Grid item xs={12}>
                  <Field
                    fullWidth
                    name="bankName"
                    component={TextField}
                    type="text"
                    label="Bank Name"
                  />
                  </Grid>               
                 <Grid item xs={12} style={{ marginTop: 16,width:"100%" }} >
                  {/* <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                    style={{width:"100%"}}
                    onClick={()=>HandleChange(values)}
                  >
                    Submit Details
                  </Button> */}
                  <div className={classes.wrapper}>
                  <Button
                  fullWidth
                     variant="contained"
                     color="primary"
                     type="submit"
                    className={buttonClassname}
                    disabled={loading}
                    // onClick={()=>handleButtonClick(values)}
                  >
                    Update Details
                  </Button>
                  {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
                    <Alert  severity="success">
                      Payment Details added Successfully!
                    </Alert>
                  </Snackbar>
                </div>
                </Grid>               
                </Grid>
            </Paper>
          </form>
        )}
      />
      </Container>
     </AppProvider>
    </div>
  );
}
export default UpdatePaymentDetails